import katex from 'katex';
import 'katex/dist/katex.min.css';

import hljs from 'highlight.js/lib/core';
import hljsBash from 'highlight.js/lib/languages/bash';
import hljsC from 'highlight.js/lib/languages/c';
import hljsCS from 'highlight.js/lib/languages/csharp';
import hljsCPP from 'highlight.js/lib/languages/cpp';
import hljsCSS from 'highlight.js/lib/languages/css';
import hljsDiff from 'highlight.js/lib/languages/diff';
import hljsHTTP from 'highlight.js/lib/languages/http';
import hljsJSON from 'highlight.js/lib/languages/json';
import hljsJava from 'highlight.js/lib/languages/java';
import hljsMakefile from 'highlight.js/lib/languages/makefile';
import hljsMarkdown from 'highlight.js/lib/languages/markdown';
import hljsObjectiveC from 'highlight.js/lib/languages/objectivec';
import hljsPHP from 'highlight.js/lib/languages/php';
import hljsPerl from 'highlight.js/lib/languages/perl';
import hljsPython from 'highlight.js/lib/languages/python';
import hljsRuby from 'highlight.js/lib/languages/ruby';
import hljsSQL from 'highlight.js/lib/languages/sql';
import hljsShell from 'highlight.js/lib/languages/shell';
import hljsXML from 'highlight.js/lib/languages/xml';
import 'highlight.js/styles/github.css';

import '@fontsource/nunito/300.css';
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import '@fontsource/nunito/900.css';
import '@fontsource/nunito/300-italic.css';
import '@fontsource/nunito/400-italic.css';
import '@fontsource/nunito/600-italic.css';
import '@fontsource/nunito/700-italic.css';
import '@fontsource/nunito/900-italic.css';
import '@fontsource/archivo/900.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/anton/400.css';
import '@fontsource/prompt/700.css';
import '@fontsource/prompt/400.css';
import '@fontsource/lobster/400.css';
import '@fontsource/roboto/900.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/400.css';
import '@fontsource/lato/900.css';
import '@fontsource/lato/400.css';
import '@fontsource/raleway/700.css';
import '@fontsource/raleway/400.css';
import '@fontsource/pacifico/400.css';
import '@fontsource/pt-sans/700.css';
import '@fontsource/pt-sans/400.css';
import '@fontsource/sofia/400.css';
import '@fontsource/arvo/700.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/400.css';
import '@fontsource/opendyslexic';

window.katex = katex;

window.hljs = hljs;
hljs.registerLanguage('bash', hljsBash);
hljs.registerLanguage('c', hljsC);
hljs.registerLanguage('csharp', hljsCS);
hljs.registerLanguage('cpp', hljsCPP);
hljs.registerLanguage('css', hljsCSS);
hljs.registerLanguage('diff', hljsDiff);
hljs.registerLanguage('http', hljsHTTP);
hljs.registerLanguage('json', hljsJSON);
hljs.registerLanguage('java', hljsJava);
hljs.registerLanguage('makefile', hljsMakefile);
hljs.registerLanguage('markdown', hljsMarkdown);
hljs.registerLanguage('objectivec', hljsObjectiveC);
hljs.registerLanguage('php', hljsPHP);
hljs.registerLanguage('perl', hljsPerl);
hljs.registerLanguage('python', hljsPython);
hljs.registerLanguage('ruby', hljsRuby);
hljs.registerLanguage('sql', hljsSQL);
hljs.registerLanguage('shell', hljsShell);
hljs.registerLanguage('xml', hljsXML);
